import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const saleCommissionPdf = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();
    const userName = store.state.user.user.name;

    const exportToPDF = (company, tableItems, totalValue, month, incentiveSetupWise) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(tableItems, totalValue, month, incentiveSetupWise),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'Sale Commission Payout - ' + formatYearMonth(month),
            }
        }

        pushIntoTable(doc, tableItems, totalValue)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    function formatYearMonth(value) {
        if (!value) return '';
        const [year, month] = value.split('-');
        return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long' })
            .format(new Date(year, month - 1));
    }

    const getContent = (tableItems, totalValue, month, incentiveSetupWise) => {
        const content = [
            {
                text:  'Sale Commission Payout - ' + formatYearMonth(month),
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            getSummaryCardSection(totalValue),
        ]

        if (incentiveSetupWise && incentiveSetupWise.length) {
            content.push(getIncentiveSetupWiseSection(incentiveSetupWise))
        }

        content.push({
            style: 'tableExample',
            margin: [0, 10, 0, 0],
            table: {
                body: [],
                widths: [ '4%', '5%', '9%', '9%', '5%', '7%', '8%', '8%', '8%', '9%', '9%', '9%', '10%' ]
            },
            layout: {
                fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex === 0) ? '#f3f2f7' : null;
                },
                hLineWidth: function (i, node) {
                    return 0.5;
                },
                vLineWidth: function (i, node) {
                    return 0.5;
                }
            }
        })

        return content
    }

    const getSummaryCardSection = (totalValue) => {
        const cards = [
            { label: 'Total Sales Submission', value: commaFormat(totalValue.sale_allocation_amount) },
            { label: 'Personal Sale Commission', value: commaFormat(totalValue.personal_sale_amount) },
            { label: 'Group Sale Commission', value: commaFormat(totalValue.group_sale_commission) },
            { label: 'BP Commission', value: commaFormat(totalValue.group_bp_commission) },
            { label: 'Total Commission', value: commaFormat(totalValue.total_sale_commission) },
            { label: 'Payout Percentage', value: commaFormat(totalValue.payout_percentage) + '%' },
            { label: 'Service Charge', value: commaFormat(totalValue.service_charge) },
            { label: 'Net Commission', value: commaFormat(totalValue.net_commission) },
            { label: 'Payout Percentage (Without Service Charge)', value: commaFormat(totalValue.payout_percentage_without_service_charge) + '%' },
        ]

        const cardsPerRow = 5;
        const cardWidth = (100 / cardsPerRow).toFixed(2) + '%';
        const rows = [];

        for (let i = 0; i < cards.length; i += cardsPerRow) {
            rows.push(cards.slice(i, i + cardsPerRow));
        }

        return {
            margin: [0, 10, 0, 0],
            stack: rows.map((row) => {
                return {
                    margin: [0, 0, 0, 5],
                    columnGap: 5,
                    columns: row.map((card) => {
                        return {
                            width: cardWidth,
                            table: {
                                widths: ['100%'],
                                heights: [24, 16],
                                body: [
                                    [{ text: card.label, bold: true, fontSize: 7, color: 'black', margin: [4, 3, 4, 0] }],
                                    [{ text: card.value, bold: true, fontSize: 9, color: 'black', alignment: 'left', margin: [4, 0, 4, 3] }]
                                ]
                            },
                            layout: {
                                hLineWidth: function (i, node) {
                                    return (i === 0 || i === node.table.body.length) ? 0.5 : 0;
                                },
                                vLineWidth: function (i, node) {
                                    return (i === 0 || i === node.table.widths.length) ? 0.5 : 0;
                                },
                                hLineColor: function () { return '#d8d6e0'; },
                                vLineColor: function () { return '#d8d6e0'; }
                            }
                        }
                    })
                }
            })
        }
    }

    const getIncentiveSetupWiseSection = (incentiveSetupWise) => {
        const cardsPerRow = 5;
        const cardWidth = (100 / cardsPerRow).toFixed(2) + '%';
        const rows = [];

        for (let i = 0; i < incentiveSetupWise.length; i += cardsPerRow) {
            rows.push(incentiveSetupWise.slice(i, i + cardsPerRow));
        }

        return {
            margin: [0, 10, 0, 0],
            stack: [
                ...rows.map((row) => {
                    return {
                        margin: [0, 0, 0, 5],
                        columnGap: 5,
                        columns: row.map((item) => {
                            return {
                                width: cardWidth,
                                table: {
                                    widths: ['100%'],
                                    heights: [14, 14, 14],
                                    body: [
                                        [{ text: `${item.level_name}(${item.equivalent_designation})`, bold: true, fontSize: 7, color: 'black', margin: [4, 3, 4, 0] }],
                                        [{ text: `${commaFormat(item.payout_percentage)}%`, bold: true, fontSize: 9, color: 'black', margin: [4, 0, 4, 0] }],
                                        [{ text: `Commission: ${commaFormat(item.total_sale_commission)}`, fontSize: 7, color: 'black', margin: [4, 0, 4, 3] }]
                                    ]
                                },
                                layout: {
                                    hLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.body.length) ? 0.5 : 0;
                                    },
                                    vLineWidth: function (i, node) {
                                        return (i === 0 || i === node.table.widths.length) ? 0.5 : 0;
                                    },
                                    hLineColor: function () { return '#d8d6e0'; },
                                    vLineColor: function () { return '#d8d6e0'; }
                                }
                            }
                        })
                    }
                })
            ]
        }
    }

    const pushIntoTable = (doc,tableItems, totalValue) => {
        const tableBlock = doc.content.find((block) => block.style === 'tableExample');
        const tableHeader = getTableHeader();
        tableBlock.table.body.push(tableHeader);
        let rows = getCommissionTable(tableItems);
        tableBlock.table.body.push(...rows);

        tableBlock.table.body.push([
            {text: 'Total', colSpan: 5, alignment: 'left'},
            {}, {}, {}, {},
            {text: commaFormat(totalValue.allocated_sales_amount), alignment: 'right'},
            {text: commaFormat(totalValue.personal_sale_amount), alignment: 'right'},
            {text: commaFormat(totalValue.group_sale_commission), alignment: 'right'},
            {text: commaFormat(totalValue.company_sale_share), alignment: 'right'},
            {text: commaFormat(totalValue.group_bp_commission), alignment: 'right'},
            {text: commaFormat(totalValue.total_sale_commission), alignment: 'right'},
            {text: commaFormat(totalValue.service_charge), alignment: 'right'},
            {text: commaFormat(totalValue.net_commission), alignment: 'right'},
        ]);

        tableBlock.table.body.push([
            {text: 'Total Sales Submission', colSpan: 12, alignment: 'left'},
            {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
            {text: commaFormat(totalValue.sale_allocation_amount), alignment: 'right'},
        ]);

        tableBlock.table.body.push([
            {text: 'Payout Percentage(%)', colSpan: 12, alignment: 'left'},
            {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
            {text: commaFormat(totalValue.payout_percentage) + '%', alignment: 'right'},
        ]);
    }

    const getCommissionTable = (tableItems) => {
        const body = [];

        tableItems.forEach((item, index) => {
            body.push([
                {text: index + 1},
                {text: item.serial_no},
                {text: item.name},
                {text: `${item.level_name} (${item.equivalent_designation})`},
                {text: item.parent_serial_no},
                {text: commaFormat(item.allocated_sales_amount), alignment: 'right'},
                {text: commaFormat(item.personal_sale_amount), alignment: 'right'},
                {text: commaFormat(item.group_sale_commission), alignment: 'right'},
                {text: commaFormat(item.company_sale_share), alignment: 'right'},
                {text: commaFormat(item.group_bp_commission), alignment: 'right'},
                {text: commaFormat(item.total_sale_commission), alignment: 'right'},
                {text: commaFormat(item.service_charge), alignment: 'right'},
                {text: commaFormat(item.net_commission), alignment: 'right'},
            ]);
        });

        return body;
    }

    const getTableHeader = () => {
        const tableHeader = [
            {text: '#SL', fontSize: 6},
            {text: 'Staff ID', fontSize: 6},
            {text: 'Staff Name', fontSize: 6},
            {text: 'Designation', fontSize: 6},
            {text: 'Ref ID', fontSize: 6},
            {text: 'Sales Amount', alignment: 'right', fontSize: 6},
            {text: 'Personal Sales Commission', alignment: 'right', fontSize: 6},
            {text: 'Group Sales Commission', alignment: 'right', fontSize: 6},
            {text: 'Company Sales Share', alignment: 'right', fontSize: 6},
            {text: 'BP Commission', alignment: 'right', fontSize: 6},
            {text: 'Total Commission', alignment: 'right', fontSize: 6},
            {text: 'Service Charge', alignment: 'right', fontSize: 6},
            {text: 'Net Commission', alignment: 'right', fontSize: 6},
        ]

        return tableHeader
    }

    return {
        exportToPDF
    }
}

export default saleCommissionPdf;